export default __webpack_public_path__ + "static/media/ic-twitterBlack.a0b21c6d.svg";